import React from 'react';
import type {CourseSessionTrackerResponse} from 'src/api/ProactApiClient';
import {CourseSessionStateEnum} from 'src/api/ProactApiClient';
import {Divider} from 'src/design/atoms/Divider';
import {Stack} from 'src/design/atoms/Stack';
import {Subtitle} from 'src/design/atoms/Typography';
import {SessionGatewayAlert} from './SessionGatewayAlert';
import {SessionListView} from './SessionListView';

const HISTORY_SESSION_STATES = [
  CourseSessionStateEnum.Cancelled.toString(),
  CourseSessionStateEnum.Expired.toString(),
  CourseSessionStateEnum.Failed.toString(),
  CourseSessionStateEnum.Completed.toString(),
];

export interface CourseAssignmentOverviewContentProps {
  tracker: CourseSessionTrackerResponse;
}

/**
 * Course assignment overview body: start/continue gateway plus session history.
 * @registry Course overview body shared by the overview page and the dashboard course preview drawer.
 */
export const CourseAssignmentOverviewContent: React.FC<
  CourseAssignmentOverviewContentProps
> = ({tracker}) => (
  <Stack>
    <SessionGatewayAlert tracker={tracker} />
    <Divider />
    <Subtitle text="History" />
    <SessionListView
      assignmentId={tracker.assignment.id!}
      sessionStates={HISTORY_SESSION_STATES}
    />
  </Stack>
);
